// src/utils/encrypt.ts
import CryptoJS from 'crypto-js'

// 你的加密密钥（需要与后端保持一致，通常为16位字符串）
const SECRET_KEY = 'migu_qingyuan123'

export function aesEncrypt(word: string) {
  // 1. 处理密钥：将字符串解析为 Utf8 格式的 WordArray
  const keyUtf8 = CryptoJS.enc.Utf8.parse(SECRET_KEY);

  // 2. 执行加密
  // 模式：ECB (Electronic Codebook)
  // 填充：Pkcs7
  // 注意：这里直接传入 word 字符串，让库内部处理转换，符合图片逻辑
  const encrypted = CryptoJS.AES.encrypt(word, keyUtf8, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });

  // 3. 返回 Base64 字符串
  // CryptoJS 的 CipherParams 对象 toString() 默认返回 Base64
  return encrypted.toString();
}
